<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM18 13.9702H13L15.26 11.7102C14.35 10.6502 13.01 9.97018 11.5 9.97018C9.13 9.97018 7.15 11.6302 6.64 13.8502L5.68 13.5302C6.32 10.9102 8.68 8.97018 11.5 8.97018C13.28 8.97018 14.87 9.76018 15.97 11.0002L18 8.97018V13.9702Z"
  />
</template>
